import { z } from "zod";
import { staffCoverageGapKindValues } from "./staff-team.js";
// The team load of the Home dashboard (CHT-2026): `GET /staff/team/load`, in `apps/api/src/routes/staff-team-load-routes.ts`. The admin calls
// it only through `@lafayette/api-client` (`staff-team-load.ts`). Supervisors only.
//
// STAFF ONLY and closed, like `staff-team.ts`: strict shapes, ids, display names, counts and times. No email, no phone, no auth id, no
// message text. A count that stops at a cap says so (`capped`): it is then a lower bound and never reads as exact.
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/u;
const uuid = z.string().regex(UUID);
const displayName = z.string().min(1).max(200);
export const staffTeamLoadSchema = z.strictObject({
    generatedAt: z.iso.datetime({ offset: false }),
    /** The active people who can carry customers (concierge or supervisor), by name. */
    members: z
        .array(z.strictObject({
        staffUserId: uuid,
        displayName,
        /** Customers this person covers now (PRIMARY, BACKUP or TEMPORARY in force). */
        customers: z.number().int().min(0).max(100_000),
        /** Open conversations that wait on this person: a handoff for them, or work that needs a person. At most the cap. */
        conversations: z.number().int().min(0).max(100),
        conversationsCapped: z.boolean(),
        /** The end of the window that makes the person unavailable now. `null`: available. */
        awayUntil: z.iso.datetime({ offset: false }).nullable(),
    }))
        .max(100),
    /** `true`: more active people exist than `members` lists. */
    membersCapped: z.boolean(),
    /** The customers who have no cover now: the coverage gaps of the Coverage area, one per customer. */
    noCover: z.strictObject({
        customerCount: z.number().int().min(0).max(200),
        /** `true`: there are more than `customerCount`. */
        capped: z.boolean(),
        /** The customers that wait longest, at most three. */
        customers: z.array(z.strictObject({ id: uuid, displayName })).max(3),
        /** Why a customer has no cover: the kinds of gap found, in a fixed order. */
        reasons: z.array(z.enum(staffCoverageGapKindValues)).max(3),
    }),
});
